/* istanbul ignore file */
import { ComposedTheme, registerDefaultsForModule } from '@glu/theming';
import legacy from './themes/legacyTheme';
import ash from './themes/ashTheme';

const themes = { ash, legacy };
let defaultsRegistered = false;
export const theme = (currentTheme: ComposedTheme) => themes[currentTheme.name](currentTheme);

export default function registerAccordionDefaults() {
  if (!defaultsRegistered) {
    registerDefaultsForModule('accordion', theme);
    defaultsRegistered = true;
  }
}
